export default "__VITE_ASSET__E9IVA9Yy__"